import { render, staticRenderFns } from "./ReviewOrganizer.vue?vue&type=template&id=3770f336&scoped=true&"
import script from "./ReviewOrganizer.vue?vue&type=script&lang=js&"
export * from "./ReviewOrganizer.vue?vue&type=script&lang=js&"
import style0 from "./ReviewOrganizer.vue?vue&type=style&index=0&id=3770f336&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3770f336",
  null
  
)

export default component.exports